import { WA_NUMBER } from '@/lib/supabase';

export function WhatsAppFab() {
  const text = encodeURIComponent('Hola, me interesa conocer sus productos.');
  return (
    <a
      className="wa-fab"
      href={`https://wa.me/${WA_NUMBER}?text=${text}`}
      target="_blank"
      rel="noopener"
      aria-label="WhatsApp"
    >
      <i className="fab fa-whatsapp" />
      <span className="wa-tip">Escríbenos por WhatsApp</span>
    </a>
  );
}
